import React from 'react'
import { Box } from '@mui/material'
import SparkBuilderCanvasSkeleton from 'sharedComponents/Skeleton/SparkBuilderCanvasSkeleton'

function SparkStepsLoader() {
  return (
    <Box
      sx={{ flexGrow: 1 }}
      display='flex'
      flexDirection='column'
      alignItems='center'
      maxWidth={'100%'}
      margin='5rem 10rem 0 14rem'
    >
      <SparkBuilderCanvasSkeleton count={4} />
    </Box>
  )
}

export default SparkStepsLoader
